'use client';;
import { Fragment, useState, useContext, useCallback } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { makeStyles } from 'tss-react/mui';
import AppContext from '../contexts/app';

const useStyles = makeStyles()((theme) => ({
  notificationsIcon: {
    color: theme.palette.text.secondary,
    margin: theme.spacing(0, 1),
  },
  loginButton: {
    marginLeft: theme.spacing(1),
  },
  desktopOnly: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

const HeaderAuth = () => {
  const {
    isLoggedIn,
    loggedInUser,
    login,
    logout,
  } = useContext(AppContext);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const { classes } = useStyles();
  const pathname = usePathname();

  const openMenu = useCallback((event) => {
    setMenuAnchorEl(event.currentTarget);
  }, []);

  const closeMenu = useCallback(() => {
    setMenuAnchorEl(null);
  }, []);

  // Close menu when route changes
  const [prevPathname, setPrevPathname] = useState(pathname);
  if (pathname !== prevPathname) {
    setPrevPathname(pathname);
    setMenuAnchorEl(null);
  }

  if (isLoggedIn) {
    return (
      <Fragment>
        <IconButton component={Link} href="/notifications" className={classes.notificationsIcon}>
          <Badge
            variant="dot"
            invisible={!loggedInUser || !loggedInUser.unreadNotificationsCount}
            color="primary"
            overlap="circular"
          >
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <IconButton
          aria-label="Account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={openMenu}
        >
          <AccountCircle />
        </IconButton>
        <Menu
          anchorEl={menuAnchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(menuAnchorEl)}
          onClose={closeMenu}
        >
          <MenuItem
            component={Link}
            href={`/people/${loggedInUser.username}`}
          >
            Profile
          </MenuItem>
          <MenuItem
            component={Link}
            href="/account"
          >
            Account
          </MenuItem>
          <MenuItem
            component={Link}
            href="/event-series"
          >
            Your Event Series
          </MenuItem>
          <MenuItem
            component={Link}
            href="/image-uploads"
          >
            Your Photos
          </MenuItem>
          <MenuItem
            component={Link}
            href="/groups"
          >
            Your Groups
          </MenuItem>
          <MenuItem
            component={Link}
            href="/people/following"
          >
            Your Following
          </MenuItem>
          <MenuItem
            component={Link}
            href="/calendar/subscribe"
          >
            Subscribe to Calendar
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              e.preventDefault();
              logout(pathname);
            }}
          >
            Log Out
          </MenuItem>
        </Menu>
      </Fragment>
    );
  }

  return (
    <Button
      variant="outlined"
      onClick={() => {
        login(pathname);
      }}
      className={classes.loginButton}
    >
      <Fragment>
        <span className={classes.desktopOnly}>
          Sign Up or{'\u00A0'}
        </span>
        Log In
      </Fragment>
    </Button>
  );
};

export default HeaderAuth;
